import { AfterViewInit, Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MonitoringImage } from '../../cctv-monitoring.models';

@Component({
  selector: 'app-image-dialog',
  templateUrl: './image-dialog.component.html',
  styleUrls: ['./image-dialog.component.css'],
})
export class ImageDialogComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() image!: MonitoringImage;
  @Input() images: MonitoringImage[] = [];
  @Output() readonly close = new EventEmitter<void>();
  currentImage!: MonitoringImage;
  modalImageFailed = false;
  imageTime = 'زمان نامشخص';
  private previousFocus: HTMLElement | null = null;

  ngOnInit(): void {
    this.currentImage = this.image;
    this.updateImageTime();
    this.previousFocus = document.activeElement instanceof HTMLElement ? document.activeElement : null;
  }

  ngAfterViewInit(): void {
    document.getElementById('image-dialog-close')?.focus();
  }

  ngOnDestroy(): void {
    this.previousFocus?.focus();
  }

  selectModalCategory(category: 'cabin' | 'outside'): void {
    const image = this.images.find(item => item.unitId === this.currentImage.unitId && item.category === category);
    if (image) { this.currentImage = image; this.modalImageFailed = false; this.updateImageTime(); }
  }

  private updateImageTime(): void {
    const time = Date.parse(this.currentImage.date);
    this.imageTime = Number.isFinite(time)
      ? new Date(time).toLocaleString('fa-IR', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' })
      : 'زمان نامشخص';
  }

  hasModalCategory(category: 'cabin' | 'outside'): boolean {
    return this.images.some(item => item.unitId === this.currentImage.unitId && item.category === category);
  }

  @HostListener('document:keydown.escape')
  onEscape(): void { this.close.emit(); }

  @HostListener('document:keydown.tab', ['$event'])
  onTab(event: KeyboardEvent): void {
    const controls = Array.from(document.querySelectorAll<HTMLElement>('.image-dialog button:not([disabled]), .image-dialog a[href]'));
    if (!controls.length) return;
    const first = controls[0];
    const last = controls[controls.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }
}
